<template>
    <Popup position="bottom" v-model="panelShow" @click-overlay="$emit('cancel')">
        <Picker
                ref="myPicker"
                show-toolbar
                :columns="data"
                :title="title"
                @confirm="onConfirm"
                @change="onChange"
                @cancel="$emit('cancel')"
        >
        </Picker>
    </Popup>
</template>

<script>
import { Icon, NavBar, Picker, Popup } from "vant";

export default {
  props: {
    data: { type: Array, required: true },
    title: { type: String, default: "请选择" },
    show: { type: Boolean, default: false },
    left: { type: String, default: "取消" },
    right: { type: String, default: "确定" },
    leftColor: { type: String, default: "red" },
    rightColor: { type: String, default: "#228EFA" }
  },
  components: {
    Popup,
    Picker,
    Icon,
    NavBar
  },
  data() {
    return {
      text: this.data.length && this.data[0].text,
      value: this.data.length && this.data[0].value
    };
  },
  watch: {
    data(value) {
      (this.text = value.length && value[0].text),
        (this.value = value.length && value[0].value);
    }
  },
  computed: {
    panelShow: {
      set(v) {
        return v;
      },
      get() {
        return this.show;
      }
    }
  },
  methods: {
    onConfirm(item) {
      this.$emit("ok",  { text: this.text, value: this.value });
    },
    onChange(e) {
      const selected = e.getValues();
      this.text = selected[0].text;
      this.value = selected[0].value;
    }
  },
  mounted(){
  }
};
</script>
